import { Variable } from 'hooks/module/useVariables';
import { Trash2 } from 'lucide-react';
import { ModuleApiOutputType } from './apiOutputContainer';
import { ApiOutputItemBooleanSelect } from './apiOutputItemBooleanSelect';
import { ApiOutputItemNumberInput } from './apiOutputItemNumberInput';
import { ApiOutputItemStringInput } from './apiOutputItemStringInput';
import { ApiOutputItemTypeSelect } from './apiOutputItemTypeSelect';
import { ApiOutputItemVariableSelect } from './apiOutputItemVariableSelect';

interface ApiOutputItemProps {
  item: ModuleApiOutputType;
  onChange: (updatedItem: ModuleApiOutputType) => void;
  onDelete: (id: string) => void;
}

export function ApiOutputItem({ item, onChange, onDelete }: ApiOutputItemProps) {
  return (
    <div className='flex gap-2'>
      <div className='flex-1 shrink-0'>
        <input
          className='w-full border-b border-gray-300 bg-transparent px-2 py-1'
          value={item.key}
          onChange={(e) => onChange({ ...item, key: e.target.value })}
        />
      </div>
      <ApiOutputItemTypeSelect
        typeSelected={item.type}
        onChange={(type) => {
          let value;
          if (type === 'boolean') {
            value = true;
          } else if (type === 'number') {
            value = 0;
          } else if (type === 'string') {
            value = '';
          } else {
            // type === 'variable'
            value = {};
          }
          onChange({ ...item, type, value });
        }}
      />
      <div className='flex-1 shrink-0'>
        {item.type === 'variable' ? (
          <ApiOutputItemVariableSelect
            value={item.value as Variable}
            onChange={(value) => onChange({ ...item, value })}
          />
        ) : item.type === 'string' ? (
          <ApiOutputItemStringInput
            value={item.value + ''}
            onChange={(value) => onChange({ ...item, value })}
          />
        ) : item.type === 'number' ? (
          <ApiOutputItemNumberInput
            value={+item.value}
            onChange={(value) => onChange({ ...item, value })}
          />
        ) : (
          <ApiOutputItemBooleanSelect
            value={Boolean(item.value)}
            onChange={(value) => onChange({ ...item, value })}
          />
        )}
      </div>
      <div className='flex basis-1/12 items-center justify-center'>
        <button onClick={() => onDelete(item.id)}>
          <Trash2 size={10} className='text-red-500' />
        </button>
      </div>
    </div>
  );
}
